import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Сталася помилка. Спробуйте ще раз.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const login = (email, password) =>
  client.post("/auth/login", { email, password }).then((r) => r.data);
export const register = (email, password, name) =>
  client.post("/auth/register", { email, password, name }).then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);

// Device sharing (owner -> another registered user by email)
export const getDeviceShares = (id) =>
  client.get(`/devices/${id}/shares`).then((r) => r.data);
export const shareDevice = (id, email) =>
  client.post(`/devices/${id}/share`, { email }).then((r) => r.data);
export const unshareDevice = (id, userId) =>
  client.delete(`/devices/${id}/share/${userId}`).then((r) => r.data);

// Admin panel
export const adminGetUsers = () => client.get("/admin/users").then((r) => r.data);
export const adminApproveUser = (id) =>
  client.post(`/admin/users/${id}/approve`).then((r) => r.data);
export const adminRejectUser = (id) =>
  client.post(`/admin/users/${id}/reject`).then((r) => r.data);
export const adminUpdateUser = (id, payload) =>
  client.patch(`/admin/users/${id}`, payload).then((r) => r.data);
export const adminDeleteUser = (id) =>
  client.delete(`/admin/users/${id}`).then((r) => r.data);
export const adminGetDevices = () =>
  client.get("/admin/devices").then((r) => r.data);
export const adminUpdateDeviceAccess = (id, payload) =>
  client.patch(`/admin/devices/${id}/access`, payload).then((r) => r.data);
export const adminDbStats = () => client.get("/admin/db_stats").then((r) => r.data);
export const adminPurge = (scope, confirm) =>
  client.post("/admin/purge", { scope, confirm }).then((r) => r.data);
export const adminGetGroups = () => client.get("/admin/groups").then((r) => r.data);
export const adminUpdateGroupOwner = (id, email) =>
  client.patch(`/admin/groups/${id}/owner`, { email }).then((r) => r.data);

export const getDevices = () => client.get("/devices").then((r) => r.data);
export const getDevice = (id) => client.get(`/devices/${id}`).then((r) => r.data);
export const createDevice = (payload) =>
  client.post("/devices", payload).then((r) => r.data);
export const deleteDevice = (id) =>
  client.delete(`/devices/${id}`).then((r) => r.data);

export const getMeasurements = (topic, key, minutes = 60) =>
  client
    .get("/measurements", { params: { topic, key, minutes } })
    .then((r) => r.data);

export const getDeviceEnergy = (id, period, date) =>
  client
    .get(`/devices/${id}/energy`, { params: { period, date } })
    .then((r) => r.data);

export const getDeviceProfile = (id, date) =>
  client
    .get(`/devices/${id}/profile`, { params: { date } })
    .then((r) => r.data);

export const getDeviceHistory = (id, month) =>
  client
    .get(`/devices/${id}/history`, { params: { month } })
    .then((r) => r.data);

export const getBatteryProfile = (id, date) =>
  client
    .get(`/devices/${id}/battery_profile`, { params: { date } })
    .then((r) => r.data);

export const getCellProfile = (id, date) =>
  client
    .get(`/devices/${id}/cell_profile`, { params: { date } })
    .then((r) => r.data);

export const getCellTempProfile = (id, date) =>
  client
    .get(`/devices/${id}/cell_temp_profile`, { params: { date } })
    .then((r) => r.data);

export const getStateLog = (id, date) =>
  client
    .get(`/devices/${id}/state_log`, { params: { date } })
    .then((r) => r.data);

export const getGroups = () => client.get("/groups").then((r) => r.data);
export const createGroup = (name) =>
  client.post("/groups", { name }).then((r) => r.data);
export const deleteGroup = (id) =>
  client.delete(`/groups/${id}`).then((r) => r.data);
export const updateGroup = (id, name) =>
  client.put(`/groups/${id}`, { name }).then((r) => r.data);
export const reorderGroups = (ids) =>
  client.put(`/groups/reorder`, { ids }).then((r) => r.data);
export const updateDeviceGroup = (id, group_id) =>
  client.patch(`/devices/${id}`, { group_id }).then((r) => r.data);
export const updateDevice = (id, payload) =>
  client.patch(`/devices/${id}`, payload).then((r) => r.data);

export default client;
